import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import { APModel } from '../../global/models/ap_model';
import { APAlternatePlanListItem } from '../builders/ap_alternate_plan_list_item_builder';
import { IAPAlternatePlanListDatasource } from '../datasources/alternate_plan_list_datasource';

interface IAPAlternatePlansData {
  current_plan: APAlternatePlanListItem;
  available_plans: APAlternatePlanListItem[];
}

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadAlternatePlanListCommand',
    function loadAlternatePlanListCommand(
      defineCommandORM: IDefineCommand,
      ngAPAlternatePlanListDatasource: IAPAlternatePlanListDatasource,
      ngAPModel: APModel,
      $http: ng.IHttpService,
      ngAPNotificationDelegate: INotificationDelegate,
      log: any
    ) {
      return defineCommandORM('loadAlternatePlanListCommand', (deferred: ng.IDeferred<IQuery[]>) => {
        const currentProgram = _4.head(_4.toArray(ngAPModel.read().program));
        $http
          .get(`/academicplan/programs/${currentProgram.id}/available_plans/`)
          .then((response: { data: IAPAlternatePlansData }) => {
            const currentPlan = response.data.current_plan || {};
            const availablePlans = response.data.available_plans || [];
            const alternatePlansData = [currentPlan, ...availablePlans];
            ngAPAlternatePlanListDatasource.clear().write(alternatePlansData);
            deferred.resolve();
          })
          .catch((e: any) => {
            const errorMessage = 'failed to get alternate plan list';
            ngAPNotificationDelegate.error(errorMessage);
            log.error(errorMessage);
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/commands/load_alternate_plan_list_command.ts